/**
 * Warning shown in Unlimited mode before a refunded order item is added to the return request.
 */
import { observer } from "mobx-react-lite";
import React from "react";
import { ConfirmModal } from "../../../components/modal/components/confirm-modal/confirm-modal";
import useDashboardTranslation from "../../../dashboard-translation/hooks/dashboard-translation-hook";

interface IProps {
    itemName: string;
    onCancel: () => void;
    onApprove: () => void;
}

const RefundedItemConfirmModal: React.FC<IProps> = observer(({ itemName, onCancel, onApprove }) => {
    const { getTranslation } = useDashboardTranslation();
    const pageScope = 'dashboard-create-rma';

    return (
        <ConfirmModal
            title={getTranslation('REFUNDED_ITEM_WARNING_TITLE', pageScope, [itemName])}
            text={getTranslation('REFUNDED_ITEM_WARNING_BODY', pageScope)}
            cancelButton={{
                title: getTranslation('REFUNDED_ITEM_WARNING_CANCEL', pageScope),
                onClick: onCancel,
            }}
            okButton={{
                title: getTranslation('REFUNDED_ITEM_WARNING_APPROVE', pageScope),
                onClick: onApprove,
            }}
        />
    );
});

export default RefundedItemConfirmModal;
